import script from "./access-restriction.vue?vue&type=script&lang=ts&setup=true"
export * from "./access-restriction.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__